import React, { PureComponent } from "react";

export class DiamondOrigin extends PureComponent {
    propTypes = {
        selectedOrigin: this.propTypes,
        selectOrigin: this.propTypes
    }

    render = () => {
        const { selectedOrigin, selectOrigin } = this.props;

        return (
            <div className="DiamondOrigin">
                <div className="DiamondOrigin-Category">
                    <div
                        className={(selectedOrigin === "11" ? "DiamondOrigin-Tab_isSelected " : "") + "DiamondOrigin-Tab"}
                        onClick={() => selectOrigin("11")}
                    >
                        <span>Natural</span>
                    </div>

                    <div
                        className={(selectedOrigin === "12" ? "DiamondOrigin-Tab_isSelected " : "") + "DiamondOrigin-Tab"}
                        onClick={() => selectOrigin("12")}
                    >
                        <span>Lab Grown</span>
                    </div>
                </div>
            </div>
        );
    }
}

export default DiamondOrigin;